module.exports = __webpack_public_path__ + "img/ikea.ab3119c6.svg";